export default __webpack_public_path__ + "static/media/0xc58158c14d4757ef36ce25e493758f2fceedec5d.a74a3889.jpg";